import { Account } from '@/domain/usecases'
import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { OnboardingSkillsRecommended } from '@/domain/usecases/onboarding/onboarding-skills-recommended'
import { QueryClient } from 'react-query'
import OnboardingBaseLoader from './onboarding-base-loader'

export default class OnboardingStep4OptionsLoader extends OnboardingBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  async loader() {
    const [makeRemoteOnboardingOptions, makeRemoteOnboardingSkillsRecommended] = await Promise.all([
      super.importRemoteModule('makeRemoteOnboardingOptions'),
      super.importRemoteModule('makeRemoteOnboardingSkillsRecommended')
    ])

    const remoteOnboardingOptions = makeRemoteOnboardingOptions(
      this.queryClient
    ) as OnboardingOptions
    const remoteOnboardingSkillsRecommended = makeRemoteOnboardingSkillsRecommended(
      this.queryClient
    ) as OnboardingSkillsRecommended

    const [step4Options, skillsRecommendedByAreas] = await Promise.all([
      remoteOnboardingOptions.getStep4(),
      remoteOnboardingSkillsRecommended.getStepRecommendSkillByAreas()
    ])

    return this.defer({
      data: {
        ...step4Options,
        skillsRecommendedByAreas
      }
    })
  }
}
